<template>
    <div class="tile is-child">
        <section class="tile is-child">
            <div class="card">
                <header class="card-header">
                    <p class="card-header-title title is-5 has-text-weight-light">{{ $t('shop.cart.epreferences') }}</p>
                </header>
                <div class="card-content" >

                    <div v-for="candidate in candidates" v-if="isLoggedIn && hasCandidates">
                        <transition name="component-fade" mode="out-in">
                            <component
                                    :is="schoolingItemsView"
                                    :candidate="candidate"
                                    :checkout="false"
                                    :status="'pending'">
                            </component>
                        </transition>
                    </div>
                    <div>
                        <transition name="component-fade" mode="out-in">
                            <component
                                    :is="offerItemsView"
                                    :checkout="false"
                                    :status="'pending'">
                            </component>
                        </transition>
                    </div>
                    <div>
                        <transition name="component-fade" mode="out-in">
                            <component
                                    :is="guestItemsView"
                                    :checkout="false"
                                    :status="'pending'">
                            </component>
                        </transition>
                    </div>
                </div>

                <footer class="card-footer" v-if="totalCheckout">
                    <span class="card-footer-item"><span><i>{{ $t('shop.cart.price') }} :</i> <strong>{{ totalCheckout }} {{ schoolCurrency() }}</strong></span></span>
                </footer>
                <footer class="card-footer" v-if="cartHasChoiceItems || guestOfferChoices.length">
                    <a class="card-footer-item has-background-success has-text-white"  @click="displayCheckout()">
                        {{ $t('shop.cart.checkout') }}
                    </a>
                </footer>
            </div>
        </section>

        <transition name="component-fade" mode="in-out" v-if="isLoggedIn">
            <section class="tile is-child" v-if="checkedoutOrders.length">
                <hr>
                <b-collapse class="card" :open="checkedoutOrders.length <= 4">
                    <div slot="trigger" slot-scope="props" class="card-header">
                        <p class="card-header-title is-size-5 has-text-weight-light">
                            <i>{{ $t('shop.orders.checkedout') }}</i>
                        </p>
                        <a class="card-header-icon">
                            <b-icon
                                    type="is-primary"
                                    size="is-medium"
                                    :icon="props.open ? 'chevron-down' : 'chevron-up'">
                            </b-icon>
                        </a>
                    </div>
                    <div class="card-content">

                        <div class="content">
                            <div v-for="order in checkedoutOrders">
                                <transition name="component-fade" mode="out-in">
                                    <component
                                            :is="checkedOutView"
                                            :order="order">
                                    </component>
                                </transition>
                            </div>
                        </div>
                    </div>
                </b-collapse>


            </section>
        </transition>

        <transition name="component-fade" mode="in-out" v-if="isLoggedIn">
            <section class="tile is-child " v-if="savedItems.length">
                <hr>
                <div class="card">
                    <header class="card-header">
                        <p class="card-header-title title is-5 has-text-weight-light">{{ $t('shop.cart.save_item') }}</p>
                    </header>
                    <div class="card-content">
                        <div v-for="candidate in candidates">
                            <transition name="component-fade" mode="out-in">
                                <component
                                        :is="savedItemsView"
                                        :candidate="candidate"
                                        :status="'saved'">
                                </component>
                            </transition>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>

    import {mapActions, mapGetters} from 'vuex'
    import SchoolingItemsView from './SchoolingItems'
    import GuestItemsView from './GuestItems'
    import OfferItemsView from './OfferItems'
    import SavedItemsView from './SavedItems'
    import CheckedOutView from '../orders/CheckedOut'
    import CompleteView from '../order/Complete'

    export default {
        data () {
            return {
                schoolingItemsView: SchoolingItemsView,
                guestItemsView: GuestItemsView,
                offerItemsView: OfferItemsView,
                savedItemsView: SavedItemsView,
                checkedOutView: CheckedOutView,
                completeView: CompleteView
            }
        },
        props: {
            candidates: { type: Array }
        },
        computed: {
            ...mapGetters(
                'orders', [
                    'candidateChoicesByCategory',
                    'savedItems',
                    'checkedoutOrders',
                    'completeOrders',
                    'totalCheckout',
                    'checkoutStatus',
                    'hasCandidateOrder',
                    'cartHasChoiceItems',
                    'guestOfferChoices'
                ]
            ),
            ...mapGetters(
                'organization', [
                    'getSchoolBySlug'
                ]
            ),
            ...mapGetters(
                'auth', [
                    'isLoggedIn'
                ]
            ),
            ...mapGetters('candidate', [
                'hasCandidates'
            ]),
            pendingOrder () {
                return this.checkoutStatus === 'pending'
            }

        },
        methods: {
            displayCheckout()  {
              if (this.isLoggedIn) {
                  if (this.$route.matched[0].meta.schoolType === 'highschool') {
                      this.$router.push({ name: 'highschool-checkout'})
                  }
                  if (this.$route.matched[0].meta.schoolType === 'eschool') {
                      this.$router.push({ name: 'eshop-checkout'})
                  }

              }  else {
                  this.$router.push({ name: 'connection-highschool'})
              }
            },
            schoolCurrency () {
                const school = this.getSchoolBySlug(this.$route.params.school)
                if (school) {
                    return school.fees_currency
                }
            }
        }
    }
</script>
